import React, { createContext, useContext, useReducer } from 'react';
import { useNavigate } from 'react-router';
import { reducer } from './edicion-socio.reducer';

const EdicionSocioContext = createContext({});

const INITIAL_STATE = {
  infoSocio: {},
  activeStep: 0,
}

export const EdicionSocioProvider = ({ children }) => {
  const navigate = useNavigate();
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);
  const { infoSocio, activeStep } = state;

  const setInitialData = (initialData) => dispatch({
    type: 'SET_INITIAL',
    payload: {
      ...INITIAL_STATE,
      ...initialData
    }
  });

  const setInfoSocio = (value) => dispatch({
    type: 'SET_SOCIO',
    payload: value
  });

  const goNextStep = () => dispatch({ type: 'SET_NEXT_STEP' });

  const goPreviousStep = () => {
    if (activeStep === 0) {
      navigate("/home/socio");
    } else {
      dispatch({ type: 'SET_PREVIOUS_STEP' });
    }
  };

  return (
    <EdicionSocioContext.Provider
      value={{
        infoSocio,
        activeStep,
        setInitialData,
        setInfoSocio,
        goNextStep,
        goPreviousStep,
      }}
    >
      {children}
    </EdicionSocioContext.Provider>
  );
};

export const useEdicionSocio = () => useContext(EdicionSocioContext);